import { BULK_PERMISSION_NAME } from '../../constants';
import type { AppRolePermissionForm } from '../../types';

export function mapFormToAppPermissionIds(form: AppRolePermissionForm) {
  const appPermissionIds: string[] = [];

  for (const [category, names] of Object.entries(form)) {
    for (const [name, actions] of Object.entries(names)) {
      // NOTE: `bulk` is a client-only checkbox state, it is not an actual app permission
      if (name === BULK_PERMISSION_NAME) continue;

      for (const [action, isEnabled] of Object.entries(actions)) {
        if (isEnabled) appPermissionIds.push(`${category}.${name}-${action}`);
      }
    }
  }

  return appPermissionIds;
}
